import React from 'react';
import Loader from 'components/loaderComponent';

const LoadingSummary = () => {
  return (
    <div className="w-full h-full rounded-5 bg-base-content absolute top-0 left-0 px-4 py-3 flex flex-col items-center justify-center">
      <Loader className="desktop:w-[2rem] desktop:h-[2rem] w-[2rem] h-[2rem]" />
      <p className="text-neutral-800 font-semibold">
        We are loading your appointment summary...
      </p>
      <p className="text-sm font-medium text-med-gray-3">
        This may take a few minutes
      </p>
    </div>
  );
};

export default LoadingSummary;
